export class MascaraUtil {

  // =========================
  // REMOVER MÁSCARA (GENÉRICO)
  // =========================
  static remover(valor: string): string {
    if (!valor) return '';
    return valor.replace(/\D/g, '');
  }

  // =========================
  // CEP — 00000-000
  // =========================
  static formatarCep(valor: string): string {
    if (!valor) return '';

    valor = this.remover(valor);

    return valor
      .replace(/(\d{5})(\d)/, '$1-$2')
      .substring(0, 9);
  }

  // =========================
  // CPF — 000.000.000-00
  // =========================
  static formatarCpf(valor: string): string {
    if (!valor) return '';

    valor = this.remover(valor);

    return valor
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{2})$/, '$1-$2')
      .substring(0, 14);
  }

  // =========================
  // TELEFONE FIXO — (00) 0000-0000
  // =========================
  static formatarTelefoneFixo(valor: string): string {
    if (!valor) return '';

    valor = this.remover(valor);

    return valor
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .substring(0, 14);
  }

  // =========================
  // TELEFONE CELULAR — (00) 00000-0000
  // =========================
  static formatarTelefoneCelular(valor: string): string {
    if (!valor) return '';

    valor = this.remover(valor);

    return valor
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .substring(0, 15);
  }

}
